/** 回购 */
<template>
  <div class="commit-withdrawal-wrap margin-top-20">
    <BasiceLayout
      :title="$t('pageTitle') "
      class=" revenue-all-layout  margin-top-20 commit-wrap"
    >
      <!-- 余额  -->
      <el-row
        v-if="balance !== 'NONE'"
        class="margin-top-20"
      >
        <el-col :span="10">
          <div class="left-wrap">{{$t('balanceText')}}</div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap right-wrap"
        >{{(balance || balance === 0) ? balance : '-'}} BXC
        </el-col>
      </el-row>
      <el-row v-if="balance !== 'NONE'">
        <!-- 当前JD卡兑换单价 -->
        <el-col :span="10">
          <div class="left-wrap">
            <div>当前提现单价</div>
          </div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap right-wrap"
        >{{RMBPrice || '-'}} 元
        </el-col>
        <!-- 可兑换JD卡总额 -->
        <el-col :span="10">
          <div class="left-wrap">
            可提现总额
          </div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap right-wrap"
        >{{canExchangeMoney || '-'}} 元</el-col>
      </el-row>
      <!-- 可兑换JD卡总额 -->
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10">
          <div class="left-wrap">需要提现金额
          </div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap"
        >
          <input
            type="text"
            class="input right-input "
            v-model="exchangeMoney"
          >
          <span class="bonus-tips margin-left-20">{{errorInfo}}</span>
        </el-col>
      </el-row>
      <!-- 兑换所需BxC数量 -->
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10">
          <div class="left-wrap">提现所需BxC数量</div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap right-wrap"
        >{{ exchangeBXC || '-'}} BXC
        </el-col>
      </el-row>
      <!-- 到账金额 -->
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10">
          <div class="left-wrap real-money ">
            <div>到账金额</div>
            <span class="bonus-tips">到账金额为代扣税点后金额</span>
          </div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap right-wrap"
        >{{realMoney || '-'}} 元
        </el-col>
      </el-row>
      <!-- 收款支付宝账号 -->
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10">
          <div class="left-wrap">收款支付宝账号
          </div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap"
        >
          <input
            type="text"
            class="input right-input"
            placeholder="输入收款支付宝账号"
            v-model="ZFBAccount"
          >
        </el-col>
      </el-row>
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10">
          <div class="left-wrap">收款支付宝姓名
          </div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap"
        >
          <input
            type="text"
            class="input right-input"
            placeholder="输入收款支付宝姓名"
            v-model="ZFBName"
          >
        </el-col>
      </el-row>
      <!-- 兑换所需BxC数量 -->
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10">
          <div class="verify-key withdrawal-key">{{$t('withdrawal.commitWith.verify')}}</div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap"
        >
          <vue-recaptcha
            class="captcha-wrap"
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
            data-size="normal"
            :sitekey="sitekey"
          />
        </el-col>
      </el-row>
      <el-row v-if="balance !== 'NONE'">
        <el-col :span="10">
          <div class="left-wrap">{{$t('withdrawal.commitWith.emailCode')}}</div>
        </el-col>
        <el-col
          :span="14"
          class="commit-right-wrap"
        >
          <SendEmailCode
            class="send-wrap right-input"
            v-model="inputEmailCode"
            :response="response"
            :email="email"
            @emailCodeTip="emailCodeTip"
          ></SendEmailCode>
        </el-col>
      </el-row>
      <div
        v-if="balance !== 'NONE'"
        class="buttonWrap"
      >
        <div
          v-bind:class="[{ 'button-disabled': !canCommit}, 'button']"
          @click="sureBuyBack"
        >{{$t('confirm')}}</div>
      </div>
      <div
        v-if="balance === 'NONE'"
        class="withdrawal-upgrade"
      >{{$t('withdrawal.withUpgrade')}}</div>
    </BasiceLayout>

  </div>
</template>

<i18n>
{
  "en": {
    "pageTitle": "提现申请",
    "balanceText": "当前BxC余额",
    "lastSevenDayPrice": "当前JD卡兑换单价",
    "buyBackAccount": "输入回购数量",
    "buyBackTitle": "USDT充值码",
    "addressNotYet": "暂未生成",
    "addressCommited": "已提交，等待生成新的充值码。",
    "showAddress": "查看",
    "dialogTitle": "查看充值码",
    "commitSuccess": "提交回购成功，会在 5 个工作日直接转账至填写的支付宝账号"
  }
}
</i18n>

<script>
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import TencentVerify from "@/components/Common/TencentVerify.vue";
import SendEmailCode from "@/components/SendEmailCode.vue";
import { mapActions, mapState } from "vuex";
import { Message } from "element-ui";
import { messageTips } from "../../utils/tips.js";
import { SITEKEY } from "../../config/contant.js";
import VueRecaptcha from "vue-recaptcha";
import { log } from "util";

export default {
  name: "AccountLayout",
  props: {
    type: "",
  },
  components: {
    BasiceLayout,
    TencentVerify,
    SendEmailCode,
    VueRecaptcha,
  },
  computed: mapState({
    //  箭头函数可使代码更简练
    email: (state) => state.account.email,
    balance: (state) => state.withdrawal.balance,
    RMBPrice: (state) => state.buyBack.RMBPrice,
    discount: (state) => state.buyBack.discount,
    minAmount: (state) => state.buyBack.minAmount,
    maxAmount: (state) => state.buyBack.maxAmount,
    // 可兑换JD卡总额
    canExchangeMoney() {
      if (this.balance && this.RMBPrice) {
        return parseInt(this.RMBPrice * this.balance);
      }
    },
    // 兑换BXC
    exchangeBXC() {
      if (this.balance && this.RMBPrice && this.exchangeMoney) {
        return Math.ceil(this.exchangeMoney / this.RMBPrice);
      }
    },
    // 到账金额
    realMoney() {
      if (this.exchangeBXC && this.discount) {
        return Math.round(this.exchangeMoney * this.discount);
      }
    },
    errorInfo() {
      if (this.exchangeMoney) {
        if (
          this.exchangeMoney < this.minAmount ||
          this.exchangeMoney > this.maxAmount
        ) {
          return `最小提现金额为 ${this.minAmount} 元，最大提现金额为 ${this.maxAmount} 元`;
        } else if (this.exchangeMoney > this.canExchangeMoney) {
          return "JD卡总额不足";
        } else if (this.discount == 0.95 && this.exchangeMoney % 1000 !== 0) {
          return "只支持以百为单位的整数提现";
        } else if (this.discount == 0.94 && this.exchangeMoney % 100 !== 0) {
          return "只支持以百为单位的整数提现";
        } else {
          return "";
        }
      }
    },
    canCommit() {
      return (
        this.canExchangeMoney >= this.minAmount &&
        this.exchangeMoney <= this.maxAmount
      );
    },
  }),
  data() {
    return {
      ticket: "",
      csnonce: "",
      // amount: "",
      inputEmailCode: "",
      response: "",
      sitekey: SITEKEY["LOW"], //ga verify key
      exchangeMoney: "",
      ZFBAccount: "",
      ZFBName: "",
    };
  },
  created() {
    // 查询余额
    this.getWithdrawalBalance();
    // 查询7天均价&usdt充值码状态
    this.getLastSevenDayPrice({ type: this.type });
  },
  methods: {
    ...mapActions([
      "commitBuyBack",
      "getWithdrawalList",
      "getWithdrawalBalance",
      "getLastSevenDayPrice",
      "getBuybackAddress",
      "getBuyBackList",
    ]),
    onVerify: function (response) {
      this.response = response;
    },
    onExpired: function () {
      Message({
        message: this.$t("captcha.expired"),
        type: "error",
      });
      this.$refs.recaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
    },
    emailCodeTip(error) {
      if (error.message) {
        Message({
          type: "error",
          message: error.message,
        });
      }
    },
    // update 验证ticket
    changeTicket(verify) {
      verify.ticket && (this.ticket = verify.ticket);
      verify.csnonce && (this.csnonce = verify.csnonce);
    },
    // 提交回购
    sureBuyBack() {
      let {
        inputEmailCode,
        canExchangeMoney,
        canCommit,
        exchangeMoney,
        ZFBAccount,
        ZFBName,
        realMoney,
        RMBPrice,
        discount,
        exchangeBXC,
      } = this;

      if (!canCommit || !ZFBAccount || !ZFBName) {
        return false;
      }

      if (!inputEmailCode) {
        messageTips("limit_email_code", this.$i18n.locale);
      } else if (
        !exchangeMoney ||
        isNaN(exchangeMoney) ||
        Number(exchangeMoney) > Number(canExchangeMoney)
      ) {
        messageTips("buyback_amount_error", this.$i18n.locale);
      } else {
        this.$confirm(
          `兑换价值 ${exchangeMoney} 元的JD卡总额，收款到账金额为 ${realMoney}(支付宝账号: ${ZFBAccount}, 支付宝姓名: ${ZFBName})`,
          {
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
          }
        ).then(() => {
          this.commitBuyBack({
            RMBPrice,
            inputEmailCode,
            canExchangeMoney,
            canCommit,
            exchangeMoney,
            ZFBAccount,
            ZFBName,
            realMoney,
            discount,
            exchangeBXC,
          }).then((res) => {
            if (res.code === 200) {
              // messageTips('', this.$i18n.locale);
              Message({
                type: "success",
                message: this.$t("commitSuccess"),
              });
              this.getBuyBackList();
            } else {
              Message({
                type: "error",
                message: res.message || "network error",
              });
            }
          });
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="stylus">
.addr-status {
  margin: 40px;
  color: #909399;
}

.last-price-key {
  margin: 10px 0;
}

.commit-wrap {
  .left-wrap {
    width: 100%;
    color: #96999b;
    text-align: right;
    height: 50px;
    font-size: 14px;
    line-height: 50px;
    margin: 10px 0;
  }

  .right-wrap {
    margin: 10px 0;
    height: 50px;
    line-height: 50px;
    font-size: 24px;
  }

  .right-input {
    width: 230px;
    height: 40px;
    margin: 15px 0;
  }

  .captcha-wrap {
    margin: 15px 0;
  }

  .real-money {
    line-height: 30px;
  }
}
</style>

